export const environment = {
  production: true,
  rememberMeKey: 'FG_W_RM_D',
  base_url: 'https://devapi.fgsnapp.com/api/v1/Ecommerce/',
  image_url:'https://devapi.fgsnapp.com/api/v1/upload/uploadFile',
  storageKey: 'FG_W_SK_D',
  googleKey: ''
};
    